
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {TranslateResult} from "vue-i18n";

@Component({})
export default class RelayAddGuests extends Vue {

    @Prop({default: null})
    public companyId: number;

    @Prop({default: null})
    public guests: any;
    public searchTimeout: any = null;
    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private contacts: any = [];
    private search: string = null;
    private newGuests: any = [];

    public async mounted() {
        this.getContacts();
        this.newGuests = await JSON.parse(JSON.stringify(this.guests));
    }

    @Watch("search")
    public handlerSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getContacts();
      }, 500);
    }

    @Watch("newGuests")
    public handlernewGuests() {
        this.$emit("update:guests", this.newGuests);
    }

    private getContacts() {
        if (!this.canDoInEnvCompany("READ_CONTACTS")) {
            return this.$store.commit("alerts/displayError", {
                msg: this.$t("alerts.error.cantFetchUsers"),
            });
        }
        const p: Array<Promise<any>> = [
            this.$store.dispatch("companies/getContacts", {
                id: this.companyId,
                query: {
                    page : 1,
                    itemsPerPage : 10,
                    search: this.search,
                    groups: true,
                },
            }),
            this.$store.dispatch("companies/getUserGroups", {
                id: this.companyId,
                query: {
                    page : 1,
                    itemsPerPage : 10,
                    search: this.search,
                    type: "contacts",
                    includeUsersCount: true,
                },
            }),
        ];
        Promise.all(p).then(([contacts, contactsGroups]) => {
            this.contacts = [
                ...contacts?.users || [],
                ...contactsGroups?.list || [],
            ].map((item: any) => ({...item}));
        });
    }

    private getUserGroupPictureSrc(group: any) {
        return group?.type === "user"
            ? group?.Users?.[0]?.picturePath
            : null;
    }

    private getUserGroupPictureDefaultImg(group: any) {
        return group?.type === "user"
            ? "user"
            : "user-group";
    }

    private disableDuplicates(completeList, duplicates) {
        if (!completeList || !duplicates) {
            return null;
        }
        return completeList.map(
            (item: any) => {
                return duplicates.map((elem: any) => elem?.id)?.includes(item?.id) ? {...item, disabled: true} : item;
            },
        );
    }

    private remove(item) {
        const index = this.newGuests.findIndex((i: any) => i?.id === item.id);
        if (index >= 0) {
            this.newGuests.splice(index, 1);
        }
    }
}
